import { useState, useEffect } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../assets/img/logo-software.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-git.png';
import navIcon3 from '../assets/img/youtube.png';
import resume from '../assets/img/Shubham__Resume.pdf';
// import { HashLink } from 'react-router-hash-link';

function NavBar() {
    const [ activeLink, setActiveLink ] = useState('home');
    const [ scrolled, setScolled ] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if(window.screenY > 50){
                setScolled(true)
            }else{
                setScolled(false)
            }
        }

        window.addEventListener("scroll" , onScroll);

        return () => window.removeEventListener,("scroll", onScroll);
    }, [])

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    // const onResumeClick = () => {
    //     console.log("Resume Download")
    // }

  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container>
      <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav" className='collapse'>
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
              <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
              <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
              <Nav.Link href={resume} className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} download="Shubham's Resume">Resume download</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/shubham-ovhal" target='blank'><img src={navIcon1} alt="" /></a>
                <a href="https://github.com/shubham1328" target='blank'><img src={navIcon2} alt="" /></a>
                <a href="https://www.youtube.com/@lifebelike8533" target='blank'><img src={navIcon3} alt="" /></a>
              </div>
              {/* <HashLink to='#connect'> */}
                <button className="vvd"><span>Let’s Connect</span></button>
              {/* </HashLink> */}
            </span>
          </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;